import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {inboxRoutes} from './inbox.route';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {InboxReducer} from './store/reducers/inbox.reducers';
import {InboxEffects} from './store/effects/inbox.effects';
import {ParticleService} from '@core/services/particle.service';
import {InboxDynamicComponentHelper} from './inbox-dynamic-component-helper';
import {InboxComponent} from './components/inbox/inbox.component';
import {InboxSidenavComponent} from './components/sidenavs/inbox-sidenav.component';
import {InboxComposeDialogComponent} from './components/compose/compose.component';
import {InboxApiService} from './services/inbox-api.service';
import {PlatformMailCellViewerComponent} from './components/cell-components/platform-mail-cell-viewer/platform-mail-cell-viewer.component';
import {MailTemplateContentComponent} from './components/mail-template-content/mail-template-content.component';
import {ReplyMessageComponent} from './components/mail-templates/reply-message/reply-message.component';
import {MailThreadComponent} from './components/mail-thread/mail-thread.component';
import {MailThreadSingleContentComponent} from './components/mail-thread-single-content/mail-thread-single-content.component';
import {EmailThreadContainerComponent} from '@features/inbox/components/email-thread-container/email-thread-container.component';
import {EmailContentEditorComponent} from '@features/inbox/components/email-content-editor/email-content-editor.component';
import {SingleEmailContainerComponent} from '@features/inbox/components/single-email-container/single-email-container.component';
import {PlatformDialogDefinitionEmailThreadEditorComponent} from '@features/inbox/editors/platform-dialog-definition-email-thread-editor/platform-dialog-definition-email-thread-editor.component';
import {MailboxListComponent} from './components/mailbox-list/mailbox-list.component';
import {PlatformMailCardViewerComponent} from './components/cell-components/platform-mail-card-viewer/platform-mail-card-viewer.component';
import {InboxControllerService} from '@features/inbox/services/inbox-controller.service';
import {AdminPanelDynamicComponentHelper} from '@features/admin-panel/admin-panel-dynamic-component-helper';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformToolInboxHandler} from '@features/inbox/platform-tool-handlers/platform-tool-inbox-handler';
import {CommandService} from '@core/services/command.service';
import {SharedPipesModule} from '@shared/shared-pipes.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(inboxRoutes),
    StoreModule.forFeature('inbox', InboxReducer),
    EffectsModule.forFeature([InboxEffects]),
    SharedModule,
    SharedPipesModule,
  ],
  declarations: [
    InboxComponent,
    InboxSidenavComponent,
    InboxComposeDialogComponent,
    PlatformMailCellViewerComponent,
    MailTemplateContentComponent,
    ReplyMessageComponent,
    MailThreadComponent,
    MailThreadSingleContentComponent,
    EmailThreadContainerComponent,
    SingleEmailContainerComponent,
    EmailContentEditorComponent,
    PlatformDialogDefinitionEmailThreadEditorComponent,
    MailboxListComponent,
    PlatformMailCardViewerComponent
  ],
  exports: [
    InboxComponent,
    InboxSidenavComponent,
    InboxComposeDialogComponent,
    PlatformMailCellViewerComponent,
    MailTemplateContentComponent,
    MailThreadComponent,
    EmailThreadContainerComponent
  ],
  providers: [
    InboxApiService,
    InboxControllerService
  ]
})
export class InboxModule {
  constructor(private commandService: CommandService,
              private platformToolInboxHandler: PlatformToolInboxHandler) {

    InboxDynamicComponentHelper.init();
    InboxDynamicComponentHelper.register('PlatformToolInboxHandler', platformToolInboxHandler);

    const command = new PlatformCommand('InboxToolLinkCommand', Api.InboxApi);
    this.commandService.registrPlatformLinkCommand('/mail/:label', command);
  }
}
